// extracted by mini-css-extract-plugin
export default {"DesktopIcon":"DesktopIcon_DesktopIcon__eaY3X","DesktopIcon__image":"DesktopIcon_DesktopIcon__image__5Ckhg","DesktopIcon__label":"DesktopIcon_DesktopIcon__label__YyKgx"};